import React from "react";
import { Box, Button, Container, Typography, styled } from "@mui/material";
import MosierLogo from "./../utils/images/mosier-logo.png";

const GradientBackground = styled(Box)({
  padding: "2rem",
  color: "black",
});

function ScheduleConsultation({ consultationConfig, contact }) {
  return (
    <Container sx={{ px: { xs: 0, md: "1rem" }, py: 10 }} maxWidth="sm">
      <Box sx={{ textAlign: "center", mb: 8 }}>
        <Typography
          variant="h4"
          component="h1"
          sx={{
            fontWeight: "bold",
            mb: 2,
            fontSize: "32px",
          }}
        >
          {consultationConfig.title?.original}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            maxWidth: "800px",
            mx: "auto",
            fontSize: "18px",
          }}
        >
          {consultationConfig.body?.original}
        </Typography>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
        <Button
          variant="primary"
          sx={{
            bgcolor: "rgb(116, 192, 174)",
            fontSize: "20px",
            px: 5,
            textTransform: "none",
            borderRadius: "10px",
            border: "1px solid rgba(17,17,17)",
            boxShadow: "rgb(17, 17, 19) -4px 4px 0px 0px",
          }}
          onClick={() =>
            window.open(consultationConfig.button_link?.original, "_blank")
          }
        >
          {consultationConfig.button_text?.original}
        </Button>
      </Box>
      <Box
        sx={{
          textAlign: "center",
          mt: "150px",
          border: "1px solid rgb(17,17,17)",
          borderRadius: "10px",
          boxShadow: "rgb(17, 17, 19) -4px 4px 0px 0px",
          p: 4,
        }}
      >
        <Box
          sx={{
            width: "170px",
            height: "170px",
            borderRadius: "50%",
            margin: "auto",
            border: "1px solid rgb(17,17,17)",
            boxShadow: "rgb(17, 17, 19) -4px 4px 0px 0px",
            zIndex: 10,
            marginTop: "-125px",
          }}
        >
          <img
            src={MosierLogo}
            alt="schedule consultation"
            style={{
              width: "100%",
              height: "100%",
              borderRadius: "50%",
              backgroundColor: "white",
              padding: "10px",
              objectFit: "contain",
            }}
          />
        </Box>
        <Typography variant="h5" sx={{ mt: 2 }}>
          {contact.name?.original}
        </Typography>
        <Typography variant="body1" sx={{ mt: 2 }}>
          {contact.company?.original}
        </Typography>
        <Box
          sx={{
            borderTop: "1px solid black",
            width: "75%",
            margin: "auto",
            marginTop: "1rem",
          }}
        />
        <Typography variant="body2" sx={{ mt: 2 }}>
          {contact.email?.original}
        </Typography>
        <Typography variant="body2" sx={{ mt: 2 }}>
          {contact.phone_number?.original}
        </Typography>
        <Typography variant="body2" sx={{ mt: 2 }}>
          {contact.website?.original}
        </Typography>
      </Box>
    </Container>
  );
}

export default ScheduleConsultation;
